import React from 'react'
import { Container } from './styles'

export const AboutMe = () => {
  return (
    <Container>
      <h2>About Me</h2>
      <p>
        A little about me. Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Ipsam necessitatibus tenetur dolore dicta ducimus unde, nobis praesentium harum quae aspernatur quo, 
        quisquam natus? Consequatur libero expedita animi rem fugit a.
      </p> <br></br>
      <p>
        I also like to spend a lot of time in front of a computer. Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Ipsam necessitatibus tenetur dolore dicta ducimus unde, nobis praesentium harum quae aspernatur quo, 
        quisquam natus? Consequatur libero expedita animi rem fugit a.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Ipsam necessitatibus tenetur dolore dicta ducimus unde, nobis praesentium harum quae aspernatur quo, 
        quisquam natus? Consequatur libero expedita animi rem fugit a.
      </p>
      
    </Container>
  )
}
